import axios from 'axios'

export default {
    async getProducts(products) {
        let params = "?_="+new Date().getTime();
        let url = process.env.VUE_APP_API_BASE + process.env.VUE_APP_API_PRODUCTS;
        if (products) {
            params += "&ids=" + products.join(",");            
        }
        url += params;
        var response = await axios.get(url);
        return response.data;
    },
    
    async getTranslations(idlang) {
        let url = process.env.VUE_APP_TRANSLATIONS_EN_BASE;

        switch(+idlang) {
            case 1031:
                url = process.env.VUE_APP_TRANSLATIONS_DE_BASE;
            break;
            case 1034:
                url = process.env.VUE_APP_TRANSLATIONS_ES_BASE;
            break;
        }
        
        url += '/gettext.js.php?type=json'
        var response = await axios.get(url);
        return response.data;
    },  
}